import React from 'react';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaYoutube } from 'react-icons/fa';

const SocialIcon = ({ char, url }) => {
    const getIcon = (char) => {
        switch (char.toLowerCase()) {
            case 'f':
                return <FaFacebookF />;
            case 't':
                return <FaTwitter />;
            case 'l':
                return <FaLinkedinIn />;
            case 'i':
                return <FaInstagram />;
            case 'y':
                return <FaYoutube />;
            default:
                return char.toUpperCase();
        }
    };

    return (
        <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="w-8 h-8 flex items-center justify-center border border-gray-500 text-gray-400 hover:bg-yellow-500 hover:text-black hover:border-yellow-500 transition-colors duration-300"
        >
            {getIcon(char)}
        </a>
    );
};

export default SocialIcon; 